import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import { onKeyDownHandler } from './onKeyDownHandler';
import { onFocusHandler, isFocused } from './onFocusHandler';
const getAriaSort = (columnId, sorted) => {
  const sortedHeader = sorted === null || sorted === void 0 ? void 0 : _findInstanceProperty(sorted).call(sorted, ({
    id
  }) => id === columnId);
  if (sortedHeader) {
    return sortedHeader.desc ? 'descending' : 'ascending';
  }
  return 'none';
};
export const getA11yTrGroupProps = () => ({
  role: 'rowgroup'
});
export const getA11yTrProps = () => ({
  role: 'row'
});
export const getA11yTableProps = tableLabel => ({
  role: 'table',
  'aria-label': tableLabel
});
const isTabbableHeader = type => type === 'display';
const getA11yTheadThProps = (tableId, focused, setFocused, state, columnId, type) => ({
  tabIndex: isTabbableHeader(type) ? 0 : -1,
  onFocus: onFocusHandler(focused, setFocused, state, 0, columnId),
  onKeyDown: onKeyDownHandler(focused, tableId, state),
  role: 'columnheader',
  'data-row': 0,
  'data-col': columnId,
  'data-parent': tableId
});
export const getA11yTheadThPropsSortableHeader = (tableId, sorted, focused, setFocused) => (state, columnId, type) => _objectSpread({
  'aria-sort': getAriaSort(columnId, sorted)
}, getA11yTheadThProps(tableId, focused, setFocused, state, columnId, type));
const isHiddenHeader = type => type === 'expander' || type === 'actions' || type === 'single_selection';
export const getA11yTheadThPropsHeader = (tableId, focused, setFocused) => (state, columnId, type) => isHiddenHeader(type) ? _objectSpread({
  'aria-hidden': true
}, getA11yTheadThProps(tableId, focused, setFocused, state, columnId, type)) : getA11yTheadThProps(tableId, focused, setFocused, state, columnId, type);
export const getA11yTdProps = (tableId, focused, setFocused) => (state, rowInfo, columnId, shouldBeFocusable) => ({
  role: 'cell',
  tabIndex: !shouldBeFocusable && isFocused(focused, state, rowInfo.viewIndex + 1, columnId) ? 0 : -1,
  'data-row': rowInfo.viewIndex + 1,
  'data-col': columnId,
  'data-parent': tableId,
  onFocus: onFocusHandler(focused, setFocused, state, rowInfo.viewIndex + 1, columnId),
  onKeyDown: onKeyDownHandler(focused, tableId, state)
});